'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;
exports.isType = isType;
exports.is = is;
exports.isa = isa;

var _babelTypesPatch = require('./util/babelTypesPatch');

var _babelTypesPatch2 = _interopRequireDefault(_babelTypesPatch);

var _lscNodeTypes = require('./lscNodeTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Avoiding `import` here to ensure compatibility with environments that have
// asynchronous `import`.
var t = require('babel-types');

(0, _babelTypesPatch2.default)(t);
(0, _lscNodeTypes.registerLightscriptNodeTypes)(t);

// Corrected implementation of babel `isType` that works with node types
// added by `definePluginType`.
function isType(nodeType, targetType) {
  if (nodeType === targetType) return true;

  var aliases = t.FLIPPED_ALIAS_KEYS[targetType];
  if (aliases) {
    for (var _i2 = 0, _len2 = aliases.length; _i2 < _len2; _i2++) {
      var _e = aliases[_i2];if (nodeType === _e) return true;
    }
  }return false;
}function is(type, node) {
  return node && isType(node.type, type);
} // Flipped for use with lightscript ~ operator
function isa(node, type) {
  return node && isType(node.type, type);
}exports.types = t;
exports.default = t;